import { Component, OnDestroy, OnInit } from '@angular/core';
import { ZoneInfo } from '@interfaces/rest/interfaces/zone';
import { User } from '@interfaces/user';
import { ProvinceService } from '@services/province.service';
import { RestService } from '@services/rest.service';
import { UtilsService } from '@services/utils.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-call-map',
  templateUrl: './call-map.component.html',
  styleUrls: ['./call-map.component.scss'],
})
export class CallMapComponent implements OnInit, OnDestroy {
  zoneInfo?: ZoneInfo;
  currentUser?: User;
  status = ['active', 'occupied'];

  searchParams = {
    zone: '',
    status: '',
    searchValue: ''
  };

  private subscriptions = new Subscription();

  constructor(
    private province: ProvinceService,
    private rest: RestService,
    private utils: UtilsService
  ) {
    const zoneInfoSub = this.province.zoneInfo$.subscribe(zoneInfo => {
      if (zoneInfo) {
        this.zoneInfo = zoneInfo;
        this.getZonesInfo();
      }
    });
    this.subscriptions.add(zoneInfoSub);
  }

  async ngOnInit() {
    await this.getCurrentUser();

    if (!this.zoneInfo) {
      this.zoneInfo = await this.province.getZones();
      this.getZonesInfo();
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  async getCurrentUser() {
    const resp = await this.rest.getCurrentUser();
    if (resp) {
      this.currentUser = resp;
    }
  }

  async getZonesInfo() {
    this.zoneInfo?.zones?.forEach(zone => {
      if (zone?.information && !zone?.parada) {
        const zoneParadaId = zone?.paradaRef;

        let wait = 0;
        const drivers = this.zoneInfo?.drivers.filter(driver => driver.s === 'active' && zoneParadaId && driver.z.i?.p === zoneParadaId && driver.z.i?.ep);
        const dateFirstDriver = drivers?.sort((a, b) => a.z.i?.ep! - b.z.i?.ep!)?.[0]?.z.i?.ep;
        if (dateFirstDriver) {
          const newDate = new Date(dateFirstDriver * 1000);
          wait = parseInt(this.utils.getCurrentTime(newDate, true), 10) || 0;
        }
      }
    });
  }

  async searchWithParams(ev: any) {
    this.searchParams = ev;
  }

}
